import React, { useState } from "react";
import { NavLink, useSubmit } from "react-router-dom";
import styles from "./SideBarAdmin.module.css";
import { motion } from "framer-motion";

import logo from "../../assets/shared/dishonline-logo-white.png";

// Icons
import homeIcon from "../../assets/admin/icons/home.svg";
import homeBlueIcon from "../../assets/admin/icons/home-blue.svg";
import productsIcon from "../../assets/admin/icons/products.svg";
import productsBlueIcon from "../../assets/admin/icons/products-blue.svg";
import menusIcon from "../../assets/admin/icons/menus.svg";
import menusBlueIcon from "../../assets/admin/icons/menus-blue.svg";
import ordersIcon from "../../assets/admin/icons/orders.svg";
import ordersBlueIcon from "../../assets/admin/icons/orders-blue.svg";
import pickupIcon from "../../assets/admin/icons/pickupslots.svg";
import pickupBlueIcon from "../../assets/admin/icons/pickupslots-blue.svg";
import settingsIcon from "../../assets/admin/icons/settings.svg";
import settingsBlueIcon from "../../assets/admin/icons/settings-blue.svg";
import discountsIcon from "../../assets/admin/icons/discounts.svg";
import discountsBlueIcon from "../../assets/admin/icons/discounts-blue.svg";
import collectionsIcon from "../../assets/admin/icons/collections.svg";
import collectionsBlueIcon from "../../assets/admin/icons/collections-blue.svg";
import logoutIcon from "../../assets/admin/icons/logout.svg";

const SideBarAdmin = () => {
   const submit = useSubmit();
   const [hoveredIndex, setHoveredIndex] = useState(null);

   const handleLogout = (e) => {
      e.preventDefault();
      submit(null, { action: "/logout", method: "post" });
   };

   const menuItems = [
      { name: "Home", icon: homeIcon, activeIcon: homeBlueIcon, path: "/dashboard" },
      { name: "Producten", icon: productsIcon, activeIcon: productsBlueIcon, path: "/dashboard/producten" },
      { name: "Menus", icon: menusIcon, activeIcon: menusBlueIcon, path: "/dashboard/menus" },
      {
         name: "Bestellingen",
         icon: ordersIcon,
         activeIcon: ordersBlueIcon,
         path: "/dashboard/bestellingen",
      },
      {
         name: "Ophaalmomenten",
         icon: pickupIcon,
         activeIcon: pickupBlueIcon,
         path: "/dashboard/ophaalmomenten",
      },
      {
         name: "Instellingen",
         icon: settingsIcon,
         activeIcon: settingsBlueIcon,
         path: "/dashboard/instellingen",
      },
      {
         name: "Kortingen",
         icon: discountsIcon,
         activeIcon: discountsBlueIcon,
         path: "/dashboard/kortingen",
      },
      {
         name: "Collecties",
         icon: collectionsIcon,
         activeIcon: collectionsBlueIcon,
         path: "/dashboard/collecties",
      },
   ];

   const getCurrentIndex = (isActive, index) => {
      if (hoveredIndex !== null) return hoveredIndex;
      if (isActive) return index;
      return null;
   };

   // Framer Motion Variants
   const sidebarVariants = {
      hidden: { opacity: 0, x: -20 },
      visible: { opacity: 1, x: 0, transition: { duration: 0.5, ease: "easeOut" } },
   };

   const logoVariants = {
      hidden: { opacity: 0, y: -10 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.2 } },
   };

   const linksWrapperVariants = {
      hidden: { opacity: 0 },
      visible: { opacity: 1, transition: { duration: 0.4, delay: 0.3 } },
   };

   const logoutWrapperVariants = {
      hidden: { opacity: 0, y: 10 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.5, delay: 0.5 } },
   };

   return (
      <motion.aside
         className={`py-20 px-30 bg-lg ${styles.aside}`}
         initial="hidden"
         animate="visible"
         variants={sidebarVariants}
      >
         <motion.div className="g-20" variants={linksWrapperVariants}>
            <motion.div className="mxw-200" variants={logoVariants}>
               <NavLink to="/dashboard">
                  <img src={logo} alt="DishOnline Logo" />
               </NavLink>
            </motion.div>
            <motion.div style={{ position: "relative" }} variants={linksWrapperVariants}>
               {menuItems.map((item, index) => (
                  <NavLink
                     key={index}
                     to={item.path}
                     end={item.path === "/dashboard"}
                     className={({ isActive }) =>
                        `g-20-1fr ${styles.dashboardLink} ${
                           getCurrentIndex(isActive, index) === index ? styles.active : ""
                        }`
                     }
                     onMouseEnter={() => setHoveredIndex(index)}
                     onMouseLeave={() => setHoveredIndex(null)}
                  >
                     {({ isActive }) => (
                        <>
                           {getCurrentIndex(isActive, index) === index && (
                              <motion.div
                                 layoutId="highlight"
                                 className={styles.highlight}
                                 transition={{
                                    type: "spring",
                                    stiffness: 400,
                                    damping: 30,
                                 }}
                              />
                           )}
                           <img
                              src={getCurrentIndex(isActive, index) === index ? item.activeIcon : item.icon}
                              alt={`${item.name} icoon`}
                           />
                           <span>{item.name}</span>
                        </>
                     )}
                  </NavLink>
               ))}
            </motion.div>
         </motion.div>
         <motion.div variants={logoutWrapperVariants}>
            <a href="/logout" className="g-20-1fr" onClick={handleLogout}>
               <img src={logoutIcon} alt="Uitloggen icoon" />
               <span>Uitloggen</span>
            </a>
         </motion.div>
                  
      </motion.aside>
   );
};

export default SideBarAdmin;
